<script lang="ts">import { icon, iconActive, iconHover } from "./colors";
export let size = 17;
export let active = false;
export let hover = false;
export let color = undefined;
let width = size;
let height = size;
let fill = color ? color : active ? iconActive : hover ? iconHover : icon;
$: fill = color ? color : active ? iconActive : hover ? iconHover : icon;
</script>

<svg
	{width}
	{height}
	viewBox="0 0 17 17"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	class="icon"
>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M3.34122 4.00078H7.87136C9.15662 4.00078 9.89558 4.48247 10.5382 5.44698C10.6663 5.67139 10.9564 5.70426 11.1808 5.60792C11.4381 5.51159 11.5991 5.31892 11.5991 5.06164V4.51534C11.0528 4.19459 10.6992 3.5837 10.6992 2.90934C10.6992 1.84962 11.5345 0.981445 12.5942 0.981445C13.6868 0.981445 14.5221 1.84849 14.5221 2.90934C14.5221 3.5837 14.1684 4.19459 13.6222 4.51534V11.7123C13.6222 12.2586 13.1722 12.7403 12.5942 12.7403H12.4978C11.9833 12.7403 11.5979 13.1257 11.5979 13.6402V15.5352C11.5979 16.3388 10.9236 16.9814 10.1517 16.9814H1.41333C0.642629 16.9814 0 16.3388 0 15.5352V7.34314C0 4.99704 0.996245 4.00078 3.34122 4.00078ZM2.923 6.70051H8.6738C9.18835 6.70051 9.60544 7.11759 9.60544 7.66388V10.877C9.60544 11.3916 9.18722 11.8087 8.6738 11.8087H2.923C2.37671 11.8087 1.95962 11.3916 1.95962 10.877V7.66388C1.95962 7.11759 2.37671 6.70051 2.923 6.70051Z"
		{fill}
	/>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M3.34122 4.00078H7.87136C9.15662 4.00078 9.89558 4.48247 10.5382 5.44698C10.6663 5.67139 10.9564 5.70426 11.1808 5.60792C11.4381 5.51159 11.5991 5.31892 11.5991 5.06164V4.51534C11.0528 4.19459 10.6992 3.5837 10.6992 2.90934C10.6992 1.84962 11.5345 0.981445 12.5942 0.981445C13.6868 0.981445 14.5221 1.84849 14.5221 2.90934C14.5221 3.5837 14.1684 4.19459 13.6222 4.51534V11.7123C13.6222 12.2586 13.1722 12.7403 12.5942 12.7403H12.4978C11.9833 12.7403 11.5979 13.1257 11.5979 13.6402V15.5352C11.5979 16.3388 10.9236 16.9814 10.1517 16.9814H1.41333C0.642629 16.9814 0 16.3388 0 15.5352V7.34314C0 4.99704 0.996245 4.00078 3.34122 4.00078ZM2.923 6.70051H8.6738C9.18835 6.70051 9.60544 7.11759 9.60544 7.66388V10.877C9.60544 11.3916 9.18722 11.8087 8.6738 11.8087H2.923C2.37671 11.8087 1.95962 11.3916 1.95962 10.877V7.66388C1.95962 7.11759 2.37671 6.70051 2.923 6.70051Z"
		{fill}
	/>
	<defs>
		<linearGradient
			id="paint0_linear_158_62946"
			x1="7.32529"
			y1="1.58145"
			x2="7.32528"
			y2="16.9814"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#3EFFB4" />
			<stop offset="1" stop-color="#01D180" />
		</linearGradient>
	</defs>
</svg>

<style>
	.icon {
    margin-bottom: 0.25rem
}
</style>
